module.exports = __webpack_public_path__ + "images/total8f70042796b96cfbe8b0b9f3d99c6f6b.png";